import { Reveal, MaskedLine } from "@/components/Reveal";
import { usePageTitle } from "@/lib/usePageTitle";
import { SITE } from "@/lib/content";

const SECTIONS = [
  {
    title: "Who is responsible for your data",
    body: `Brian Boland Psychotherapy & Counselling is the data controller for any personal information you share through this website. You can contact the practice at any time about your data via ${SITE.email}.`,
  },
  {
    title: "What information is collected",
    body: "When you submit the enquiry form, the practice receives your name, email address, optional phone number, your preferred way of attending (in person or online), and anything you choose to include in your message. This website does not use advertising trackers.",
  },
  {
    title: "How your information is used",
    body: "Your details are used only to respond to your enquiry, arrange appointments, and provide therapy. Information is never sold or shared with third parties for marketing. Notes kept as part of therapy are held securely and confidentially, in line with professional record-keeping obligations.",
  },
  {
    title: "Confidentiality in therapy",
    body: "What you discuss in sessions is confidential. There are a small number of legal and ethical limits — for example, where there is a serious risk of harm to you or someone else, or where disclosure is required by law. These limits are explained clearly before therapy begins.",
  },
  {
    title: "How long information is kept",
    body: "Enquiry details are kept only as long as needed to respond and, where therapy begins, client records are retained in accordance with professional and legal requirements, after which they are securely destroyed.",
  },
  {
    title: "Your rights under GDPR",
    body: "You have the right to access the personal data held about you, to have it corrected or erased, to restrict or object to its processing, and to data portability, subject to professional record-keeping obligations. To exercise any of these rights, contact the practice by email.",
  },
  {
    title: "Making a complaint",
    body: "If you are unhappy with how your data is handled, please raise it with the practice first. You also have the right to lodge a complaint with the Data Protection Commission (dataprotection.ie).",
  },
];

const Privacy = () => {
  usePageTitle("Privacy & Confidentiality", "How Brian Boland Psychotherapy & Counselling protects your personal data and keeps therapy confidential (GDPR).");
  return (
    <div data-testid="privacy-page">
      <section className="mx-auto max-w-3xl px-5 pb-16 pt-16 sm:px-8 lg:pt-24">
        <Reveal y={12}><p className="eyebrow">Privacy & Confidentiality</p></Reveal>
        <h1 className="mt-6 font-serif text-4xl font-medium leading-[1.12] tracking-tight text-[#1E2723] sm:text-5xl">
          <MaskedLine delay={0.15}>Your privacy is</MaskedLine>
          <MaskedLine delay={0.3} className="italic text-[#527363]">part of the care</MaskedLine>
        </h1>
        <Reveal delay={0.5}>
          <p className="mt-7 text-base leading-relaxed text-[#4A5750] sm:text-lg">
            Trust begins before the first session. This page explains, in plain language, how your personal information is handled and how confidentiality works in therapy.
          </p>
        </Reveal>
      </section>
      <section className="mx-auto max-w-3xl space-y-5 px-5 pb-24 sm:px-8">
        {SECTIONS.map((s, i) => (
          <Reveal key={s.title} delay={0.05 * i}>
            <article className="soft-card p-7" data-testid={`privacy-section-${i}`}>
              <h2 className="font-serif text-xl font-medium text-[#1E2723]">{s.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-[#54645B]">{s.body}</p>
            </article>
          </Reveal>
        ))}
      </section>
    </div>
  );
};

export default Privacy;
